import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1c2d2ee2/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { rowData, headerData } from '../../../data/components/data-table.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Default`}</h2>
    <ComponentDemo scope={{
      rowData,
      headerData,
      React
    }} knobs={{
      DataTable: ['isSortable'],
      Table: ['size', 'useZebraStyles']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/datatable--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-table--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdatatable--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=data-table'
    }} mdxType="ComponentDemo">{`<DataTable 
  rows={rowData} 
  headers={headerData} 
  render={({ rows, headers, getHeaderProps }) => (
  <TableContainer title="DataTable">
    <Table>
      <TableHead>
        <TableRow>
          {headers.map(header => (
            <TableHeader {...getHeaderProps({ header })}>
              {header.header}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow key={row.id}>
            {row.cells.map(cell => (
              <TableCell key={cell.id}>{cell.value}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>)}
/>`}</ComponentDemo>
    <h2>{`With expansion`}</h2>
    <ComponentDemo scope={{
      rowData,
      headerData
    }} knobs={{
      DataTable: ['isSortable'],
      Table: ['size', 'useZebraStyles']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/datatable--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-table--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdatatable--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=data-table'
    }} mdxType="ComponentDemo">{`<DataTable 
  rows={rowData} 
  headers={headerData} 
  render={({ rows, headers, getHeaderProps, getRowProps, getTableProps }) => (
  <TableContainer title="DataTable with expansion">
    <Table {...getTableProps()}>
      <TableHead>
        <TableRow>
          <TableExpandHeader />
          {headers.map(header => (
            <TableHeader {...getHeaderProps({ header })}>
              {header.header}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <React.Fragment key={row.id}>
            <TableExpandRow {...getRowProps({ row })}>
              {row.cells.map(cell => (
                <TableCell key={cell.id}>{cell.value}</TableCell>
              ))}
            </TableExpandRow>
            {row.isExpanded && (
              <TableExpandedRow colSpan={headers.length + 1}>
                <p>Aux squad rules</p>
              </TableExpandedRow>
            )}
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)}/>`}</ComponentDemo>
    <h2>{`With selection`}</h2>
    <ComponentDemo scope={{
      rowData,
      headerData
    }} knobs={{
      DataTable: ['isSortable'],
      Table: ['size', 'useZebraStyles']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/datatable--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-table--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdatatable--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=data-table'
    }} mdxType="ComponentDemo">{`<DataTable 
  rows={rowData} 
  headers={headerData} 
  render={({ rows, headers, getHeaderProps, getSelectionProps, getRowProps }) => (
  <TableContainer title="DataTable with selection">
    <Table>
      <TableHead>
        <TableRow>
          <TableSelectAll {...getSelectionProps()} />
          {headers.map(header => (
            <TableHeader {...getHeaderProps({ header })}>
              {header.header}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow {...getRowProps({ row })}>
            <TableSelectRow {...getSelectionProps({ row })} />
            {row.cells.map(cell => (
              <TableCell key={cell.id}>{cell.value}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>)}
/>`}</ComponentDemo>
    <h2>{`Sample data`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const headerData = [
  {
    header: 'Name',
    key: 'name',
  },
  {
    header: 'Protocol',
    key: 'protocol',
  },
  {
    header: 'Port',
    key: 'port',
  },
  {
    header: 'Rule',
    key: 'rule',
  },
  {
    header: 'Attached Groups',
    key: 'attached_groups',
  },
  {
    header: 'Status',
    key: 'status',
  },
];

const rowData = [
  {
    attached_groups: 'Kevins VM Groups',
    id: 'a',
    name: 'Load Balancer 3',
    port: 3000,
    protocol: 'HTTP',
    rule: 'Round robin',
    status: 'Disabled',
  },
  {
    attached_groups: 'Maureens VM Groups',
    id: 'b',
    name: 'Load Balancer 1',
    port: 443,
    protocol: 'HTTP',
    rule: 'Round robin',
    status: 'Starting',
  },
  {
    attached_groups: 'Andrews VM Groups',
    id: 'c',
    name: 'Load Balancer 2',
    port: 80,
    protocol: 'HTTP',
    rule: 'DNS delegation',
    status: 'Active',
  },
  {
    attached_groups: 'Marcs VM Groups',
    id: 'd',
    name: 'Load Balancer 6',
    port: 3000,
    protocol: 'HTTP',
    rule: 'Round robin',
    status: 'Disabled',
  },
  {
    attached_groups: 'Mels VM Groups',
    id: 'e',
    name: 'Load Balancer 4',
    port: 443,
    protocol: 'HTTP',
    rule: 'Round robin',
    status: 'Starting',
  },
  {
    attached_groups: 'Ronjas VM Groups',
    id: 'f',
    name: 'Load Balancer 5',
    port: 80,
    protocol: 'HTTP',
    rule: 'DNS delegation',
    status: 'Active',
  },
];
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      